import { render, staticRenderFns } from "./ExamQuestion.vue?vue&type=template&id=f26ed42c"
import script from "./ExamQuestion.vue?vue&type=script&lang=js"
export * from "./ExamQuestion.vue?vue&type=script&lang=js"
import style0 from "./ExamQuestion.vue?vue&type=style&index=0&id=f26ed42c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports